import { Link } from "react-router-dom";

export default function ServiceAreasSection() {
  const cities = [
    "New York, NY", "Los Angeles, CA", "Chicago, IL", "Houston, TX",
    "Phoenix, AZ", "Philadelphia, PA", "San Antonio, TX", "San Diego, CA",
    "Dallas, TX", "Jacksonville, FL", "Austin, TX", "Nashville, TN",
    "Seattle, WA", "Denver, CO", "Atlanta, GA", "Miami, FL",
  ];

  return (
    <section className="py-24 bg-[#FAFAFA]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <span className="inline-block text-[#C9A961] text-xs font-semibold uppercase tracking-widest mb-3">
            Where We Work
          </span>
          <h2
            className="text-4xl lg:text-5xl font-semibold text-[#111111] leading-tight mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Interior Design Services Nationwide
          </h2>
          <p className="text-[#5C5C5C] max-w-xl mx-auto leading-relaxed">
            The Design Proposal serves homeowners across the country through our remote-friendly process — with no location restrictions.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 mb-14">
          <div className="rounded-xl overflow-hidden border border-[#EBEBEB]" style={{ height: "380px" }}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d24178688.87258853!2d-95.7129!3d37.0902!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sus!4v1710000000000!5m2!1sen!2sus"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              title="Interior design services coverage map — United States"
            ></iframe>
          </div>

          <div className="flex flex-col justify-between">
            <div>
              <div className="grid grid-cols-2 gap-3 mb-6">
                {[
                  { icon: "ri-global-line", title: "All 50 States", desc: "Virtual design proposals available nationwide." },
                  { icon: "ri-map-pin-line", title: "Local Projects", desc: "In-person services in select metro areas." },
                  { icon: "ri-home-4-line", title: "Residential Focus", desc: "Every service built for homeowners." },
                  { icon: "ri-time-line", title: "Fast Turnaround", desc: "Proposals delivered in 5–14 business days." },
                ].map((item) => (
                  <div key={item.title} className="bg-white rounded-xl p-5 border border-[#EBEBEB]">
                    <div className="w-8 h-8 flex items-center justify-center bg-[#C9A961]/10 rounded-lg mb-3">
                      <i className={`${item.icon} text-[#C9A961] text-sm`}></i>
                    </div>
                    <div className="font-semibold text-[#111111] text-sm mb-1">{item.title}</div>
                    <p className="text-xs text-[#5C5C5C] leading-relaxed">{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-[#111111] rounded-xl p-6">
              <p
                className="text-white font-semibold text-base mb-2"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                Available in Your City
              </p>
              <p className="text-white/55 text-sm mb-4 leading-relaxed">
                We serve all 50 states virtually. Don&apos;t see your city? You&apos;re still covered.
              </p>
              <Link
                to="/location"
                className="whitespace-nowrap inline-flex items-center gap-2 bg-[#C9A961] text-white text-sm font-medium px-5 py-2.5 rounded-md hover:bg-[#b8924d] transition-colors cursor-pointer"
              >
                View All Service Areas
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </div>
              </Link>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-3">
          {cities.map((city) => (
            <div
              key={city}
              className="bg-white rounded-lg px-3 py-2.5 border border-[#EBEBEB] text-center"
            >
              <div className="text-xs font-medium text-[#111111]">{city}</div>
            </div>
          ))}
        </div>
        <p className="text-center text-sm text-[#5C5C5C] mt-6">
          Don&apos;t see your city?{" "}
          <strong className="text-[#111111]">All 50 states</strong> are served virtually.{" "}
          <Link to="/#proposal" className="text-[#C9A961] underline cursor-pointer">
            Request your proposal
          </Link>
          {" "}regardless of location.
        </p>
      </div>
    </section>
  );
}
